module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Underline-8ca5d12472f175c8705315bbf6674ab0.svg";